export const EDIT_PROFILE_START = 'EDIT_PROFILE_START';
export const EDIT_PROFILE_FAILED = 'EDIT_PROFILE_FAILED';
export const EDIT_PROFILE_SUCCESS = 'EDIT_PROFILE_SUCCESS';
